import _ from 'lodash'

export const FETCHING_EDUCATION_LEVELS = 'FETCHING_EDUCATION_LEVELS'
export const FETCHED_EDUCATION_LEVELS = 'FETCHED_EDUCATION_LEVELS'

const educationLevelsInit = {
  isFetching: false,
  data: [],
}

export const educationLevels = (educationLevels=educationLevelsInit, action) => {
  switch(action.type) {
    case FETCHING_EDUCATION_LEVELS:
      return {
        ...educationLevels,
        isFetching: true,
      }
    case FETCHED_EDUCATION_LEVELS:
      return {
        isFetching: false,
        data: action.educationLevels,
      }
    default:
      return educationLevels
  }
}

const educationLevelsOptionsInit = {
  isFetching: false,
  data: [],
}

export const educationLevelsOptions = (educationLevelsOptions=educationLevelsOptionsInit, action) => {
  switch(action.type) {
    case FETCHING_EDUCATION_LEVELS:
      return {
        ...educationLevelsOptions,
        isFetching: true,
      }
    case FETCHED_EDUCATION_LEVELS:
    const elo = _.map(
      action.educationLevels,
      educationLevelOption => ({
        text: educationLevelOption.title,
        key: `education_level_option_${educationLevelOption.id}`,
        value: educationLevelOption.id,
      })
    )
      return {
        isFetching: false,
        data: elo,
      }
    default:
      return educationLevelsOptions
  }
}
